export const prodVariables = {
  apiEndpoint: 'http://dockapp.tielbeke.nl/beheer/api/v1',
  backendEndpoint: 'http://dockapp.tielbeke.nl/beheer',
  pusherUrl: "dockapp-wss.tielbeke.nl",
  pusherKey: "wk6IEonsBWv1Jj63",
  environmentName: 'Production Environment',
  ionicEnvName: 'prod',
};



// WEBPACK FOOTER //
// ./src/app/environment-variables/production.ts